const log = (...args: unknown[]): void => {
  console.info(...args);
};

export { log };
